/*
 * We recommend using the merged theme if you want to override our core theme.
 * This means you can use our core theme and override it with your own customizations.
 * Write your overrides in the userTheme object in this file.
 * The userTheme object is merged with the coreTheme object within this file.
 * Export this file and import it in the `@components/theme/index.tsx` file to use the merged theme.
 */

// MUI Imports
import { deepmerge } from '@mui/utils'
import type { Theme } from '@mui/material/styles'

// Type Imports
import type { Settings } from '@core/contexts/settingsContext'
import type { SystemMode } from '@core/types'

// Core Theme Imports
import coreTheme from '@core/theme'

const mergedTheme = (settings: Settings, mode: SystemMode, direction: Theme['direction']) => {
  // Vars
  const userTheme = {
    colorSchemes: {
      light: {
        palette: {
          primary: {
            main: '#004E98',
            light: '#0066CC',
            dark: '#003366'
          },
          secondary: {
            main: '#9D9D9B',
            light: '#BFBFBF',
            dark: '#7A7A78'
          },
          warning: {
            main: '#FFCC00',
            light: '#FFD633',
            dark: '#CC9900'
          }
        }
      },
      dark: {
        palette: {
          primary: {
            main: '#003869',
            light: '#005A9C',
            dark: '#00264D'
          },
          secondary: {
            main: '#003869',
            light: '#005A9C',
            dark: '#00264D'
          },
          warning: {
            main: '#FFCC00',
            light: '#FFD633',
            dark: '#CC9900'
          }
        }
      }
    }
  } as Theme

  return deepmerge(coreTheme(settings, mode, direction), userTheme)
}

export default mergedTheme
